module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAr0lEQVR4AZSQsQ3CMBBFc4giBSVDMARFSlZgEioqGgok1qCjZB2QaOnozfsnYSWynTjRPTu2/0tsL5qZz6gQQmjhAMv/d4sCoZbQHc5wBa+s0AvvSD3hAl6JkAl3ZvbyNM1AmAqTb6JQE45CbTgKvKxhA6o3zQey5VsyM4U6ErqRLf2Dv67ok3JBs0i6iUkpCrXSQKiREqEgnTQvsoIWeme6MT6CV1HQqiTYw1dj8QMAAP//9mRKfwAAAAZJREFUAwB32k0hySpiuwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageLeft1.png
// module id = K44x
// module chunks = 20